module.exports = __webpack_public_path__ + "img/maatontwikkeling.216729dd.jpg";